module.exports = __webpack_public_path__ + "static/media/praia-logo.ec2be820.png";